module.exports = __webpack_public_path__ + "img/11.f97cc49c.png";